import {Box, Button, Typography} from '@mui/material'
import { Link as RouterLink, useParams } from 'react-router-dom';
import { AppContainer } from '@shared/components/AppContainer';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getMyTokensAction, getTokenAction, resetToken, tokenSelector } from '@store/slices/token.slice';
import { useEffect, useState } from 'react';
import { TokenOverview } from '@shared/components/TokenOverview';
import { appUserProfileSelector } from '@store/slices/app.slice';
import ImportTokenDialog from '@shared/components/ImportTokenDialog';

export const PublicTokenOverview = () => {
    const dispatch = useAppDispatch();
    let { id } = useParams<{ id: string }>();
    const userProfile = useAppSelector(appUserProfileSelector);
    const tokenDetails = useAppSelector(tokenSelector);
    const [importTokenOpen, setImportTokenOpen] = useState(false)

    useEffect(() => {
        console.log(tokenDetails);
        dispatch(resetToken())
        if (id) {
            dispatch(getTokenAction(id));
        }
    }, []);

    const checkForOwnership = (tokenId: string) => {
        let isOwner = false;
        isOwner = tokenDetails?.myTokens?.data?.some((userToken) => {
            return userToken.parent_id === tokenId;
        });

        return isOwner;
    }

    const checkUserLoggedIn = () => {
        return (userProfile.id !== undefined && userProfile.id !== null);
    }

    return (
        <AppContainer>
            <TokenOverview token={tokenDetails.token}>
                {/* Change this to "Token doesn't have a parent ID" */}
                {/*{tokenDetails?.token?.owner?.id !== userProfile?.id && (*/}
                {tokenDetails?.token?.parent_id === null && (
                    <>
                        <Box mb={2}>

                            {(tokenDetails?.token?.profile?.status === 'PENDING') && (
                                <Button variant="contained" disabled={true} className="w-100" size="large" color="primary"
                                    component={RouterLink} to={`/tokens/${tokenDetails?.token?.id}`}>
                                    COMING SOON</Button>
                            )}
                            {(tokenDetails?.token?.profile?.status === 'ACTIVE' && tokenDetails?.token?.profile?.contract_type === 'INTERNAL') && (
                                <Button variant="contained" className="w-100" size="large" color="primary"
                                        component={RouterLink} to={`/tokens/${tokenDetails?.token?.id}/buy`}
                                        disabled={checkForOwnership(tokenDetails?.token?.id)}>

                                    {checkForOwnership(tokenDetails?.token?.id) ? 'You already own this Membership' : 'Buy Membership'}

                                </Button>
                            )}
                        </Box>
                        {/*<Box mb={1}>
                            <Typography variant="caption" color="text.secondary">Already own this membership?</Typography>
                        </Box>
                        <Box mb={2}>
                            <Button disabled={!checkUserLoggedIn()} variant="contained" className="w-100" size="large" color="primary"
                                    target="_blank"
                                    onClick={() => setImportTokenOpen(true)} href="">Import Membership</Button>
                        </Box>*/}
                        {/*<Box mb={3}>
                            <Button disabled={true} variant="contained" className="w-100" size="large" color="primary"
                                    href={"#"}>View on OpenSea</Button>
                        </Box>*/}

                    </>
                )}
                <ImportTokenDialog open={importTokenOpen} tokenAddress={tokenDetails?.token?.profile?.contract_address} id={tokenDetails?.token?.id} chainId={+tokenDetails?.token?.profile?.blockchain_network_id} onClose={() => setImportTokenOpen(false)} />
            </TokenOverview>
        </AppContainer>
    )
}
